export const URL_SUFFIX = {
    SDK_DOCS: '/sdk-docs/',
    SDK_DOCS_PDF: '/sdk-docs/pdf/combined.pdf',
    SDK_DOCS_QUICK_START: '/sdk-docs/quick-start/',
    SDK_DOCS_SAMPLE_APP: '/sdk-docs/SampleApp/',
    SAMPLE_APP: '/materials/app.zip',
};
